import React from 'react'

class SearchBar extends React.PureComponent {
    handleChange() {
      this.props.onUserInput(this.refs.filterTextInput.value)
      //console.log(this.refs.filterTextInput.value)
    }
    render() {
      return (
          <input style={this.props.style} type="text" placeholder="חיפוש..." value={this.props.filterText} ref="filterTextInput" 
            onChange={this.handleChange.bind(this)}/>
      )
    }
}

export default SearchBar